<template>
  <div>
    <div class="booking__route-wrapper">
      <ul class="booking__routes">
        <li class="booking__routes-item">
          <input
            type="radio"
            @change="changeRouteType(1)"
            name="routeType-internal"
            value="1"
            id="oneWayInternal"
            class="radio-button"
            autocomplete="off"
            v-model="routeTypeInternal"
          />

          <label for="oneWayInternal">
            یک طرفه
          </label>
        </li>

        <li class="booking__routes-item">
          <input
            type="radio"
            @change="changeRouteType(2)"
            name="routeType-internal"
            value="2"
            id="twoWayExternal"
            class="radio-button"
            v-model="routeTypeInternal"
            autocomplete="off"
          />

          <label for="twoWayExternal">
            رفت و برگشت
          </label>
        </li>
        <li
          class="booking__routes-item booking__routes-item--has-border hide-in-not-desktop"
        >
          <select @change="selectCabinType()" v-model="cabinType">
            <option
              v-for="cabinType in cabinTypeList"
              :key="cabinType.key"
              :value="cabinType.cabinTypeNumber"
            >
              {{ cabinType.title }}
            </option>
          </select>
        </li>
      </ul>
    </div>

    <div class="booking__inner">
      <div class="booking__items">
        <div class="booking__item booking__item--departure">
          <Departure
            :title="'جستجوی نام شهر'"
            :label="'مبدا'"
            :header="'انتخاب مبدا'"
            :origin-place="true"
            airport-type="internal"
            @fill-next-input="fillNextInput"
            ref="originCity"
          />

          <button
            class="booking__reverse btn btn--white btn--square"
            @click="reverseAirports"
          >
            <i class="icon-arow-double" />
          </button>

          <Departure
            :title="'جستجوی نام شهر'"
            :label="'مقصد'"
            :header="'انتخاب مقصد'"
            :origin-place="false"
            airport-type="internal"
            @fill-next-input="fillNextInput"
            ref="destinationCity"
          />
        </div>

        <div
          class="booking__item booking__item--date"
          :class="{ 'booking__item--two-date': routeTypeInternal === 2 }"
        >
          <Datepicker
            :date-locale="locale"
            :date-format="format"
            :type="'departureDate'"
            :title="'تاریخ رفت'"
            @change-locale="changeLocale"
            @date-changed="dateChanged"
            @fill-next-input="fillNextInput"
            ref="departureDate"
          ></Datepicker>

          <Datepicker
            v-if="routeTypeInternal === 2"
            :type="'returnDate'"
            :date-locale="locale"
            :date-format="format"
            :min-date="returnDateMin"
            :title="'تاریخ برگشت'"
            @change-locale="changeLocale"
            @fill-next-input="fillNextInput"
            ref="returnDate"
          />
        </div>

        <div class="booking__item booking__item--travellers">
          <Travellers ref="travellers" />
        </div>
      </div>

      <button
        class="booking__search btn btn--primary btn--xl"
        @click="searchFlight"
        title="جستجو"
      >
        جستجو
        <i class="icon-arrow-left" />
      </button>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali";

import Departure from "./Departure.vue";
import Datepicker from "./Datepicker.vue";
import Travellers from "./Travellers.vue";
import { cabinTypeList } from "../../../../ConstantData/constants";

import { showAlert } from "../../../../Helpers/tools";

export default {
  name: "InternalFlight",

  components: {
    Departure,
    Datepicker,
    Travellers,
  },

  data() {
    return {
      baseUrl: "/fa/flight/dom/",

      routeTypeInternal: 1,

      returnDateMin: moment(Date().now).format("jYYYY/jMM/jDD"),

      originCity: "",

      destinationCity: "",

      cabinTypeList: [...cabinTypeList],

      cabinType: 0,

      selectedCabinType: cabinTypeList[0],

      isJalali: true,
    };
  },

  methods: {
    // fill next input
    fillNextInput() {
      let timeOut;

      let originCity = this.$refs.originCity;
      let destinationCity = this.$refs.destinationCity;
      let departureDate = this.$refs.departureDate;
      let returnDate = this.$refs.returnDate;

      if (!originCity.selectedAirport) {
        timeOut = setTimeout(() => {
          originCity.showDefaultAirports();
          clearTimeout(timeOut);
        }, 50);

        return;
      }

      if (!destinationCity.selectedAirport) {
        timeOut = setTimeout(() => {
          destinationCity.showDefaultAirports();
          clearTimeout(timeOut);
        }, 50);

        return;
      }

      if (!departureDate.date) {
        timeOut = setTimeout(() => {
          departureDate.$refs.datepicker.showPicker();
          clearTimeout(timeOut);
        }, 50);

        return;
      }

      if (this.routeTypeInternal === 2 && !returnDate.date) {
        timeOut = setTimeout(() => {
          returnDate.$refs.datepicker.showPicker();
          clearTimeout(timeOut);
        }, 50);

        return;
      }
    },
    selectCabinType() {
      this.cabinTypeList.map((item) => {
        if (item.cabinTypeNumber === this.cabinType) {
          this.selectedCabinType = item;
        }
      });
    },

    // change route type and hide error
    changeRouteType(type) {
      this.routeTypeInternal = type;
    },

    // get date from departureDate and set to return min date
    dateChanged(event) {
      this.returnDateMin = moment(event).format("jYYYY/jMM/jDD");

      if (this.routeTypeInternal === 2) {
        this.$refs.returnDate.date = "";
      }
    },

    // change datepicker locale
    changeLocale(type) {
      if (type === "fa,en") {
        this.isJalali = true;
      } else {
        this.isJalali = false;
      }
    },

    // reverse Airports
    reverseAirports() {
      let originCity = this.$refs.originCity;
      let destinationCity = this.$refs.destinationCity;

      [
        originCity.airportCode,
        originCity.inputValue,
        destinationCity.airportCode,
        destinationCity.inputValue,
      ] = [
        destinationCity.airportCode,
        destinationCity.inputValue,
        originCity.airportCode,
        originCity.inputValue,
      ];
    },

    // go to find flights
    searchFlight() {
      let searchUrl = this.baseUrl;
      let originCity = this.$refs.originCity;
      let destinationCity = this.$refs.destinationCity;
      let departureDate = this.$refs.departureDate.date

      let returnDate;
      if (this.routeTypeInternal === 2) {
        returnDate = this.$refs.returnDate.date
      }

      let travellers = this.$refs.travellers;

      let valid = true;

      if (originCity.airportCode && originCity.selectedAirport) {
        searchUrl += `${originCity.airportCode}-`;
      } else {
        showAlert([
          {
            type: 8,
            message: "مبدا را انتخاب کنید",
          },
        ]);

        valid = false;
      }

      if (destinationCity.airportCode && destinationCity.selectedAirport) {
        searchUrl += destinationCity.airportCode;
      } else {
        showAlert([
          {
            type: 8,
            message: "مقصد را انتخاب کنید",
          },
        ]);

        valid = false;
      }

      if (
        originCity.airportCode &&
        destinationCity.airportCode &&
        originCity.airportCode === destinationCity.airportCode
      ) {
        showAlert([
          {
            type: 8,
            message: "مبدا و مقصد نمی تواند یکسان باشد",
          },
        ]);

        valid = false;
      }

      if(this.selectedCabinType.cabinTypeNumber !== 0){
        searchUrl += `/?Cab=${this.selectedCabinType.cabinTypeNumber}&`;
      }else{
        searchUrl += `/?`
      }


      if (departureDate) {
        searchUrl += `Dep=${departureDate}`;
      } else {
        showAlert([
          {
            type: 8,
            message: "تاریخ رفت را انتخاب کنید",
          },
        ]);

        valid = false;
      }

      if (this.routeTypeInternal === 2) {
        if (returnDate) {
          searchUrl += `&Ret=${returnDate}`;
        } else {
          showAlert([
            {
              type: 8,
              message: "تاریخ برگشت را انتخاب کنید",
            },
          ]);

          valid = false;
        }
      }

      searchUrl += `&Adt=${travellers.adult}`;

      if (travellers.child > 0) {
        searchUrl += `&Chd=${travellers.child}`;
      }

      if (travellers.infant > 0) {
        searchUrl += `&Inf=${travellers.infant}`;
      }

      if (valid) {
        window.location.assign(searchUrl);
      }
    },
  },
};
</script>
